import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../../../Assets/CSS/bulkorder.css";
import { useNavigate, useParams } from "react-router-dom";
import "../../oms.css";
import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";
import FileUpload from "../../../../Assets/Images/OMS/FileUpload.svg";
import Transport from "../../../../Assets/Images/OMS_New/transport (1).svg";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import { useFormik } from "formik";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Next from "../../../../Assets/Images/OMS/Next.svg";
import { ClipLoader } from "react-spinners";
import axios from "axios";
import toast from "react-hot-toast";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import ShowPDF from "../../common/pdfViewer";
import { Modal } from "@material-ui/core";

function TransportDetailBuyerForm({
  orderId,
  orderShipmentDocs,
  getOMSData,
  omsData,
}) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";

  const [buyerTransportDetails, setBuyerTransportDetails] = useState(false);
  const [uploading, setUploading] = useState(false);
  const truckUnloadingRef = useRef(null);
  const buyerchequeRef = useRef(null);
  const [transportDetails, setTransportDetails] = useState({});
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);
  const [formDisable, setFormDisable] = useState(false);
  const [selectedTruckUnloading, setSelectedTruckUnloading] = useState([]);
  const [selectedBuyerPaid, setSelectedBuyerPaid] = useState([]);

  function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  const [docState, setDocState] = useState({
    truck_unloading_image_oms: [],
    buyer_paid_cheque_oms: [],
  });

  const selectOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];
  /*
  const onFileChange = async (event) => {
    const file = event.target.files[0];
    
      let formData = new FormData();
      formData.append("file", file); 
      setUploading(true);
      const uploadResponse = await fetch(
      "/upload/mitra-merchant/doc-upload",
      {
          method: "POST",
          body: formData,
      }
      );
      if (uploadResponse?.ok) {
      const uploadResponseData = await uploadResponse.json();
      
      if (event.target.name === 'truck_unloading_image') {
        formik.setFieldValue('truck_unloading_image', uploadResponseData.file_location);
      } else if (event.target.name === 'buyer_paid_cheque') {
        formik.setFieldValue('buyer_paid_cheque', uploadResponseData.file_location);
      }
  
      setUploading(false);
      } else {
          setUploading(false);
      throw new Error("Failed to upload file.");
      }
    }
  */

  const setInvoice = (fileLocation, event) => {
    switch (event.target.name) {
      case "truck_unloading_image":
        setDocState((prev) => ({
          ...prev,
          truck_unloading_image_oms: [
            ...prev.truck_unloading_image_oms,
            fileLocation,
          ],
        }));

        break;
      case "buyer_paid_cheque":
        setDocState((prev) => ({
          ...prev,
          buyer_paid_cheque_oms: [...prev.buyer_paid_cheque_oms, fileLocation],
        }));

        break;
    }
  };

  const onFileChange = async (event, setUrl) => {
    switch (event.target.name) {
      case "truck_unloading_image":
        setDocState((prev) => ({
          ...prev,
          truck_unloading_image_oms:
            transportDetails?.truck_unloading_image_oms || [],
        }));

        break;
      case "buyer_paid_cheque":
        setDocState((prev) => ({
          ...prev,
          buyer_paid_cheque_oms: transportDetails?.buyer_paid_cheque_oms || [],
        }));

        break;
    }
    const files = event.target.files;

    if (files.length > 0) {
      setUploading(true);

      const uploadPromises = Array.from(files).map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
          const uploadResponse = await fetch(
            "/upload/mitra-merchant/doc-upload",
            {
              method: "POST",
              body: formData,
            }
          );

          if (uploadResponse.ok) {
            const uploadResponseData = await uploadResponse.json();
            setUrl(uploadResponseData.file_location, event);
          } else {
            throw new Error("Failed to upload file.");
          }
        } catch (error) {
          setUploading(false);
          console.error("Error uploading file:", error);
        }
      });

      try {
        await Promise.all(uploadPromises);
        setUploading(false);
      } catch (error) {
        setUploading(false);
        console.error("Error uploading files:", error);
      }
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.truck_haulted_start_date && values.is_truck_halted === "yes") {
      errors.truck_haulted_start_date = "Start Date is Required";
    }
    if (!values.truck_haulted_end_date && values.is_truck_halted === "yes") {
      errors.truck_haulted_end_date = "End date is required";
    }
    if (!values.date_of_truck_arrival) {
      errors.date_of_truck_arrival = "Truck Arrival Date is Required";
    }
    if (!values.unloading_weight_bag) {
      errors.unloading_weight_bag = "Unloading Weight is Required";
    }

    // Truck details validatiom

    // values.truck_details?.forEach((truck_detail, index) => {
    //   const truck_details_errors = {};

    //   if (
    //     !truck_detail.truck_haulted_start_date &&
    //     truck_detail.is_truck_halted === "yes"
    //   ) {
    //     truck_details_errors.truck_haulted_start_date =
    //       "Start Date is Required";
    //   }
    //   if (
    //     !truck_detail.truck_haulted_end_date &&
    //     truck_detail.is_truck_halted === "yes"
    //   ) {
    //     truck_details_errors.truck_haulted_end_date = "End date is required";
    //   }

    //   if (!truck_detail.date_of_truck_arrival) {
    //     truck_details_errors.date_of_truck_arrival =
    //       "Truck Arrival Date is Required";
    //   }

    //   if (Object.keys(truck_details_errors).length) {
    //     errors.truck_details = errors.truck_details || [];
    //     errors.truck_details[index] = truck_details_errors;
    //   }
    // });

    return errors;
  };

  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };

  const handleDeleteTruckUnloading = (index) => {
    const newState = [...docState.truck_unloading_image_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      truck_unloading_image_oms: newState,
    }));
  };

  const handleDeleteBuyerCheque = (index) => {
    const newState = [...docState.buyer_paid_cheque_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      buyer_paid_cheque_oms: newState,
    }));
  };

  const handleSubmit = async (values) => {
    const payload = {
      order_id: orderId,
      truck_halt_start_time: values.truck_haulted_start_date
        ? values.truck_haulted_start_date
        : null,
      truck_halt_end_time: values.truck_haulted_end_date
        ? values.truck_haulted_end_date
        : null,
      date_of_truck_arrival: values.date_of_truck_arrival
        ? values.date_of_truck_arrival
        : null,
      is_gps_tracker_collected:
        values.is_gps_tracker_collected === "yes"
          ? true
          : values.is_gps_tracker_collected === "no"
          ? false
          : null,
      truck_unloading_image_oms: docState.truck_unloading_image_oms,
      buyer_paid_cheque_oms: docState.buyer_paid_cheque_oms,
      merchant_type: "buyer",
      is_oms: true,
      unloading_weight_bag: values.unloading_weight_bag
        ? values.unloading_weight_bag
        : null,
      is_truck_halted:
        values.is_truck_halted === "yes"
          ? true
          : values.is_truck_halted === "no"
          ? false
          : null,
      // truck_details_list: Array.isArray(values.truck_details)
      //   ? values.truck_details.map((td) => ({
      //       ...td,
      //       truck_halt_start_time: td.truck_haulted_start_date || null,
      //       truck_halt_end_time: td.truck_haulted_end_date || null,

      //       is_transport_of_supplier:
      //         td.is_transport_of_supplier === "yes"
      //           ? true
      //           : td.is_transport_of_supplier === "no"
      //           ? false
      //           : null,
      //       is_truck_halted_charges_paid:
      //         td.truck_haulted_charges_paid === "yes"
      //           ? true
      //           : td.truck_haulted_charges_paid === "no"
      //           ? false
      //           : null,
      //       is_gps_provided:
      //         td.is_gps_tracker_given === "yes"
      //           ? true
      //           : td.is_gps_tracker_giver === "no"
      //           ? false
      //           : null,
      //       truck_reached_destination:
      //         td.has_truck_reached_destination === "yes"
      //           ? true
      //           : td.has_truck_reached_destination === "no"
      //           ? false
      //           : null,
      //       is_truck_halted:
      //         td.is_truck_halted === "yes"
      //           ? true
      //           : td.is_truck_halted === "no"
      //           ? false
      //           : null,
      //       is_truck_breakdown:
      //         td.is_truck_breakdown === "yes"
      //           ? true
      //           : td.is_truck_breakdown === "no"
      //           ? false
      //           : null,
      //     }))
      //   : [],
    };

    try {
      const { data } = await axios.post("/api/oms/shipment/docs", payload);
      if (data.status) {
        formik.resetForm();
        if (truckUnloadingRef.current && buyerchequeRef.current) {
          truckUnloadingRef.current.value = "";
          buyerchequeRef.current.value = "";
        }
        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response ? error.response.message : "An error occured");
    }
  };

  const initialValues = {
    date_of_truck_arrival: null,
    unloading_weight_bag: null,
    truck_haulted_start_date: null,
    truck_haulted_end_date: null,
    is_gps_tracker_collected: null,
    truck_unloading_image: null,
    buyer_paid_cheque: null,
    is_truck_halted: null,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    const transport = orderShipmentDocs?.find(
      (obj) => obj.merchant_type === "buyer"
    );
    const transportSupp = orderShipmentDocs?.find(
      (obj) => obj.merchant_type === "supplier"
    );
    // const tds = transport?.order_shipment_docs_truck_details?.length
    //   ? transport.order_shipment_docs_truck_details
    //   : transportSupp?.order_shipment_docs_truck_details?.length
    //   ? transportSupp?.order_shipment_docs_truck_details.map((td) => ({
    //     ...td,
    //     id: ''
    //   }))
    //   : [];
    if (transport) {
      setFormDisable(true);
    } else {
      setFormDisable(false);
    }

    setTransportDetails(transport);
    setDocState((prev) => ({
      ...prev,
      truck_unloading_image_oms: transport?.truck_unloading_image_oms || [],
      buyer_paid_cheque_oms: transport?.buyer_paid_cheque_oms || [],
    }));
    formik.setValues({
      ...formik.values,
      truck_number: transportSupp?.is_truck_breakdown
        ? transportSupp?.truck_number_2
        : transportSupp?.truck_details,
      truck_chasis_number: transportSupp?.is_truck_breakdown
        ? transportSupp?.truck_chasis_number_2
        : transportSupp?.truck_chasis_number,
      date_of_truck_arrival: transport?.date_of_truck_arrival
        ? moment(transport?.date_of_truck_arrival).format("YYYY-MM-DD")
        : null,
      unloading_weight_bag: transport?.unloading_weight_bag || null,
      truck_haulted_start_date: transport?.truck_halt_start_time
        ? moment(transport?.truck_halt_start_time).format("YYYY-MM-DD")
        : null,
      truck_haulted_end_date: transport?.truck_halt_end_time
        ? moment(transport?.truck_halt_end_time).format("YYYY-MM-DD")
        : null,
      is_gps_tracker_collected:
        transport?.is_gps_tracker_collected === true
          ? "yes"
          : transport?.is_gps_tracker_collected === false
          ? "no"
          : null,
      is_gps_tracker_given:
        transportSupp?.is_gps_provided === true
          ? "yes"
          : transport?.is_gps_provided === false
          ? "no"
          : null,
      truck_unloading_image: transport?.truck_unloading_image || "",
      buyer_paid_cheque: transport?.buyer_paid_cheque || "",
      is_truck_halted:
        transport?.is_truck_halted === true
          ? "yes"
          : transport?.is_truck_halted === false
          ? "no"
          : null,
    });
  }, [orderShipmentDocs, formik.setValues]);

  let transportSupplier = useMemo(() => {
    return orderShipmentDocs?.find((obj) => obj.merchant_type === "supplier");
  }, [orderShipmentDocs]);

  return (
    <>
      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>

      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex gap-2">
            <img src={Transport} alt="" />
            <div> Transport Details</div>
            {!transportSupplier && (
              <span style={{ color: "red" }}>
                (Supplier transport not added)
              </span>
            )}
          </div>
          <div>
            {buyerTransportDetails ? (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Up}
                  alt=""
                  role="button"
                  onClick={() =>
                    setBuyerTransportDetails(!buyerTransportDetails)
                  }
                />
              </div>
            ) : (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Down}
                  alt=""
                  role="button"
                  onClick={() =>
                    setBuyerTransportDetails(!buyerTransportDetails)
                  }
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {buyerTransportDetails ? (
            <></>
          ) : (
            <div>
              <form onSubmit={formik.handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Truck Number
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      value={formik.values.truck_number}
                      disabled
                    />
                  </div>
                  <div>
                    <label
                      for="truck_chasis_number"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Truck Chasis Number
                    </label>
                    <input
                      type="text"
                      id="truck_chasis_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="truck_chasis_number"
                      placeholder="Truck Chasis Number"
                      value={formik.values.truck_chasis_number}
                      disabled
                    />
                  </div>
                  <div>
                    <label
                      for="date_of_truck_arrival"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Date of truck arrival
                    </label>
                    <input
                      type="date"
                      id="date_of_truck_arrival"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="date_of_truck_arrival"
                      placeholder="Enter Driver Name"
                      value={formik.values.date_of_truck_arrival}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.date_of_truck_arrival ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.date_of_truck_arrival}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <label
                      for="unloading_weight_bag"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Unloading weight(MT)
                    </label>
                    <input
                      type="text"
                      id="unloading_weight_bag"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="unloading_weight_bag"
                      placeholder="Enter Driver Name"
                      value={formik.values.unloading_weight_bag}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.unloading_weight_bag ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.unloading_weight_bag}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Is Truck Halted ?
                    </label>
                    <select
                      value={formik.values.is_truck_halted}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      name="is_truck_halted"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="Select Expense">Select Option</option>
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.is_truck_halted ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.is_truck_halted}
                      </div>
                    ) : null}
                  </div>

                  {formik.values.is_truck_halted === "yes" ? (
                    <>
                      <div>
                        <label
                          for="truck_haulted_start_date"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Halted Start Date
                        </label>
                        <input
                          type="date"
                          id="truck_haulted_start_date"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_haulted_start_date"
                          value={formik.values.truck_haulted_start_date}
                          onChange={formik.handleChange}
                        />
                        {formik.errors.truck_haulted_start_date ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_haulted_start_date}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label
                          for="truck_haulted_end_date"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Halted End Date
                        </label>
                        <input
                          type="date"
                          id="truck_haulted_end_date"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_haulted_end_date"
                          value={formik.values.truck_haulted_end_date}
                          onChange={formik.handleChange}
                        />
                        {formik.errors.truck_haulted_end_date ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_haulted_end_date}
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Is GPS Tracker given?
                    </label>
                    <select
                      value={formik.values.is_gps_tracker_collected}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      disabled
                    >
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Is GPS Tracker collected?
                    </label>
                    <select
                      value={formik.values.is_gps_tracker_collected}
                      onChange={formik.handleChange}
                      name="is_gps_tracker_collected"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="Select Expense">Select Option</option>
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.is_gps_tracker_collected ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.is_gps_tracker_collected}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="mt-4 mb-2 text-start ">
                  <h1 className="text-2xl text-blue-900">Documents</h1>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Truck Unloading Image</span>
                      </div>
                      {docState.truck_unloading_image_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.truck_unloading_image_oms.map(
                          (each, index) => (
                            <div key={index} className="border-2">
                              <div className="cursor-pointer flex justify-between">
                                <div></div>
                                <div
                                  onClick={() =>
                                    handleDeleteTruckUnloading(index)
                                  }
                                >
                                  <DeleteIcon />
                                </div>
                              </div>
                              {(each?.toLowerCase().endsWith(".jpg") ||
                                each?.toLowerCase().endsWith(".png") ||
                                each?.toLowerCase().endsWith(".jpeg")) && (
                                <div>
                                  <ImageIcon style={{ fontSize: "60px" }} />
                                </div>
                              )}
                              {each?.toLowerCase().endsWith(".pdf") && (
                                <div>
                                  <FileCopyIcon style={{ fontSize: "60px" }} />
                                </div>
                              )}
                              <div className="p-2">
                                <div>
                                  <button
                                    className="bg-blue-500 text-white rounded p-2 mr-2"
                                    onClick={() => handleModalOpen(each)}
                                    type="button"
                                  >
                                    View
                                  </button>
                                  <button
                                    className="bg-blue-500 text-white rounded p-2"
                                    type="button"
                                  >
                                    <a
                                      style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                      href={each}
                                    >
                                      Download
                                    </a>
                                  </button>
                                </div>
                              </div>
                            </div>
                          )
                        )
                      )}
                      <input
                        id="file"
                        type="file"
                        name="truck_unloading_image"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedTruckUnloading([...e.target.files]);
                        }}
                        className="mt-5 ml-5"
                        disabled={
                          isPending ||
                          uploading ||
                          !formik.values.truck_details?.length
                        }
                        multiple
                      />
                      {selectedTruckUnloading.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedTruckUnloading.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.truck_unloading_image ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.truck_unloading_image}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Buyer Paid Cheque</span>
                      </div>
                      {docState.buyer_paid_cheque_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.buyer_paid_cheque_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleDeleteBuyerCheque(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                      <input
                        id="file"
                        type="file"
                        name="buyer_paid_cheque"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedBuyerPaid([...e.target.files]);
                        }}
                        className="mt-5 ml-5"
                        disabled={
                          isPending ||
                          uploading ||
                          !formik.values.truck_details?.length
                        }
                        multiple
                      />
                      {selectedBuyerPaid.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedBuyerPaid.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.buyer_paid_cheque ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.buyer_paid_cheque}
                      </div>
                    ) : null}
                  </div>
                </div>
                {
                  <div>
                    {uploading ? (
                      <div>
                        <ClipLoader />
                      </div>
                    ) : (
                      <div className="flex justify-end mt-2">
                        <Button
                          variant="contained"
                          size="small"
                          type="submit"
                          sx={{ backgroundColor: "#0D9223" }}
                          disabled={
                            isPending || !formik.values.truck_details?.length
                          }
                        >
                          SAVE
                        </Button>
                      </div>
                    )}
                  </div>
                }
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TransportDetailBuyerForm;
